import newInboxRuleOperation from 'owa-service/lib/operation/newInboxRuleOperation';
import newInboxRuleRequest from 'owa-service/lib/factory/newInboxRuleRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Sends out the service request to update an inbox rule
 * @param newInboxRuleData the object that contains the new rule data
 * @return a promise that contains NewInboxRuleResponse
 */
export default function newInboxRuleService(newInboxRule) {
    var requestBody = newInboxRuleRequest({
        Header: getJsonRequestHeader(),
        InboxRule: newInboxRule,
    });
    return newInboxRuleOperation(requestBody);
}
//# sourceMappingURL=newInboxRuleService.js.map